export default {
  status: {
    pending: 1,
    finished: 2,
  },
}
